import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';

export default {
  getAboutDetails(): Promise<AxiosResponse> {
    return AxiosProvider.amsApiClient.get(`/about`);
  },
};
